module.exports = __webpack_public_path__ + "static/media/ChestYellow.dc7f6a17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-assets/sprites/ChestYellow.png
// module id = 2751
// module chunks = 0